function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.393 4a3.21 3.21 0 00-2.671 1.43l-4.867 7.3a3.21 3.21 0 00-.54 1.782v8.91a3.21 3.21 0 003.211 3.21h12.526A3.947 3.947 0 0031 22.684V16.79a3.947 3.947 0 00-3.948-3.948h-2.548a1.21 1.21 0 01-1.194-1.41l.616-3.694A3.21 3.21 0 0020.759 4h-1.366zM4.21 12.842A3.21 3.21 0 001 16.053v7.369a3.21 3.21 0 003.21 3.21h1.474a3.21 3.21 0 003.21-3.21v-7.369a3.21 3.21 0 00-3.21-3.21H4.211z",
  fill: "currentColor"
})));